import React, { useState } from 'react';
import clsx from 'clsx';
import './index.css';
interface AccordionProps {
 title: string;
 children?: React.ReactNode;
 className?: string;
 defaultOpen?: boolean;
 style?: React.CSSProperties;
 headerStyle?: React.CSSProperties;
}

const Accordion: React.FC<AccordionProps> = ({ title, children, className, defaultOpen = false, style, headerStyle }) => {
 const [open, setOpen] = useState(defaultOpen);
 return (
    <div className={clsx('lb-accordian', { 'open': open }, className )} style={style}>
      <div className="tw-flex tw-justify-between tw-items-center tw-py-2 tw-cursor-pointer" style={headerStyle} onClick={() => {setOpen(!open)}}>
        <div className="accordian-title">{title}</div>
        <svg width="18" height="11" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" className={`tw-transform ${open ? 'tw-rotate-180' : ''}`}>
          <path d="M1 1L7 7L13 1" stroke="var(--primary-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      {open && (
        <div className='accordian-content'>
          {children}
        </div>
      )}
    </div>
 );
};
export default Accordion;

//tw-transition-all tw-ease-in-out tw-duration-1000